import { Link } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { ArrowLeft, Users } from "lucide-react";
import { useMe } from "@/context/MeContext";

export const AppHeader = ({ back, title, subtitle }) => {
  const me = useMe();
  return (
    <header className="sticky top-0 z-30 bg-[#0B0C10]/90 backdrop-blur-md border-b border-[#2A2E39]">
      <div className="max-w-3xl mx-auto px-4 h-16 flex items-center gap-3">
        {back ? (
          <Link to={back} data-testid="header-back-link" className="tap-target grid place-items-center rounded-md hover:bg-[#1C2029] text-slate-300 hover:text-white transition-colors">
            <ArrowLeft className="w-5 h-5" />
          </Link>
        ) : (
          <Link to="/" data-testid="header-home-link" className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full bg-[#A9B26A] shadow-[0_0_12px_#636b2f]" />
            <span className="font-display text-lg font-black uppercase tracking-wide text-white">Memórias Póstumas</span>
          </Link>
        )}
        {back && (
          <div className="min-w-0 flex-1">
            <div className="font-display text-lg font-bold uppercase tracking-wide text-white truncate" data-testid="header-title">{title}</div>
            {subtitle && <div className="text-xs text-slate-400 truncate">{subtitle}</div>}
          </div>
        )}
        <div className="ml-auto flex items-center gap-2">
          {me?.role === "admin" && (
            <Link to="/usuarios" data-testid="header-users-link" className="tap-target grid place-items-center rounded-md hover:bg-[#1C2029] text-slate-300 hover:text-[#A9B26A] transition-colors" title="Equipe">
              <Users className="w-5 h-5" />
            </Link>
          )}
          <div data-testid="header-user-button"><UserButton /></div>
        </div>
      </div>
    </header>
  );
};
